import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import ViewerDocument from '../../../shared/components/ViewerDocument/ViewerDocument'

import useFinancialClient from '../../../clients/FinancialClient/useFinancialClient'

const AllTicketViewer = () => {
  const financialClient = useFinancialClient()
  const { documentNumber } = useParams()
  const [documentData, setDocumentData] = useState(null)

  useEffect(() => {
    financialClient().getAllTicketsInfo(documentNumber).then((response) => {
      setDocumentData(response.data)
    })
  }, [documentNumber, financialClient])

  return (
    <>
      {documentData && (
        <ViewerDocument
          documentBase64={documentData.base64}
          fileName={`${documentData.nomeSegurado}_${documentData.numeroApolice}.pdf`}
        />
      )}
    </>
  )
}

export default AllTicketViewer
